// Check if Mapbox should be used
function useMapbox() {
  // Check data attribute first (set by view template)
  const locationInput = document.getElementById('job_location');
  if (locationInput && locationInput.dataset.useMapbox === 'true') {
    return true;
  }
  // Fallback to global config (if set via window)
  return window.mapsConfig?.provider === 'mapbox' || false;
}

document.addEventListener('turbo:load', function(e) {

  /* --------------------------------------------------
                Get Location (Google Maps)
  -------------------------------------------------- */
  pgJobsFormGetLocationInit = function(){
    let locationInput = document.getElementById('job_location');
    let locationInputLat = document.getElementById('job_location_lat');
    let locationInputLng = document.getElementById('job_location_lng');

    if (locationInput) {
      // Check which provider to use
      if (useMapbox()) {
        initializeMapboxGeocoder(locationInput, locationInputLat, locationInputLng);
      } else {
        initializeGoogleAutocomplete(locationInput, locationInputLat, locationInputLng);
      }
    }
  }

  /* --------------------------------------------------
                Initialize Google Places Autocomplete
  -------------------------------------------------- */
  function initializeGoogleAutocomplete(locationInput, locationInputLat, locationInputLng) {
    // Load Google Maps API if not already loaded
    if (typeof google === 'undefined') {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${locationInput.dataset.apiKey}&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = () => setupGoogleAutocomplete(locationInput, locationInputLat, locationInputLng);
      document.head.appendChild(script);
    } else {
      setupGoogleAutocomplete(locationInput, locationInputLat, locationInputLng);
    }
  }

  function setupGoogleAutocomplete(locationInput, locationInputLat, locationInputLng) {
    const autocomplete = new google.maps.places.Autocomplete(locationInput, {
      types: ['address'],
      componentRestrictions: { country: ['us'] } // Restrict to United States
    });

    // When a place is selected from the autocomplete
    autocomplete.addListener('place_changed', function() {
      const place = autocomplete.getPlace();

      if (!place.geometry) {
        alert('No details available for input: ' + place.name);
        return;
      }

      // Update the hidden lat/lng fields
      locationInputLat.value = place.geometry.location.lat();
      locationInputLng.value = place.geometry.location.lng();
    });

    // Prevent form submission when pressing enter on the autocomplete field
    locationInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
      }
    });
  }

  /* --------------------------------------------------
                Initialize Mapbox Geocoder
  -------------------------------------------------- */
  async function initializeMapboxGeocoder(locationInput, locationInputLat, locationInputLng) {
    // Check if mapboxManager is available
    if (!window.mapboxManager) {
      console.error('MapboxManager not available');
      return;
    }

    // Get access token
    const accessToken = locationInput.dataset.accessToken;
    if (!accessToken) {
      console.error('Mapbox access token not provided');
      return;
    }

    // Load Mapbox API
    await window.mapboxManager.loadAPI(accessToken);

    // Create a dummy map object for the geocoder (required by MapboxGeocoder API)
    // We'll provide all methods the geocoder might call to prevent errors
    const dummyMap = {
      getCenter: () => ({ lng: 0, lat: 0, wrap: () => ({ lng: 0, lat: 0 }) }),
      getZoom: () => 10,
      flyTo: function() {}, // No-op function to prevent errors
      on: function() { return this; }, // Event handler stub (returns self for chaining)
      off: function() { return this; }, // Event handler stub
      getBounds: () => ({
        extend: () => {},
        getNorth: () => 0,
        getSouth: () => 0,
        getEast: () => 0,
        getWest: () => 0
      }),
      loaded: () => true,
      fire: () => {},
      _container: document.createElement('div')
    };

    // Initialize Mapbox Geocoder (now async since it loads from CDN)
    // Using documented options: marker: false and flyTo: false to work without a real map
    const geocoder = await window.mapboxManager.createGeocoder({
      accessToken: accessToken,
      mapboxgl: window.mapboxgl,
      placeholder: locationInput.placeholder || 'Search for an address',
      countries: 'us', // Restrict to United States
      types: 'address,place,region', // Allow addresses, cities, and states
      marker: false, // Don't show marker on map (we don't have a map)
      flyTo: false // Disable flyTo animation - prevents map navigation calls
    });

    // Get the geocoder's container element
    // onAdd() expects a map object, so we pass our dummy map
    // The geocoder will use the dummy map for any map method calls
    const geocoderContainer = geocoder.onAdd(dummyMap);
    geocoderContainer.className = (geocoderContainer.className || '') + ' mapbox-geocoder-container';
    
    // Insert container right after the input field
    locationInput.parentNode.insertBefore(geocoderContainer, locationInput.nextSibling);

    // Hide the original input field since geocoder has its own input
    locationInput.style.display = 'none';

    // Handle result selection
    geocoder.on('result', function(e) {
      const result = e.result;
      
      // Update location input with formatted address (for form submission)
      if (result.place_name) {
        locationInput.value = result.place_name;
      } else if (result.text) {
        // Build address from context
        const addressParts = [result.text];
        if (result.context) {
          result.context.forEach(function(item) {
            // Include place, district, locality, region, postcode
            if (['place', 'district', 'locality', 'region', 'postcode'].includes(item.id.split('.')[0])) {
              addressParts.push(item.text);
            }
          });
        }
        locationInput.value = addressParts.join(', ');
      }

      // Update the hidden lat/lng fields
      // Mapbox returns coordinates as [lng, lat]
      if (result.center && result.center.length === 2) {
        locationInputLng.value = result.center[0];
        locationInputLat.value = result.center[1];
      }

      // Trigger change events for form validation
      locationInput.dispatchEvent(new Event('change', { bubbles: true }));
      locationInputLat.dispatchEvent(new Event('change', { bubbles: true }));
      locationInputLng.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Handle errors
    geocoder.on('error', function(e) {
      console.error('Geocoder error:', e.error);
    });

    // Handle clearing
    geocoder.on('clear', function() {
      locationInput.value = '';
      locationInputLat.value = '';
      locationInputLng.value = '';
    });

    // Sync existing value to geocoder if present
    if (locationInput.value) {
      geocoder.setInput(locationInput.value);
    }
  }

  /* --------------------------------------------------
                Functions
  -------------------------------------------------- */
  pgJobsFormGetLocationInit();
});
